import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from "react-dom/client"
import { AuthProvider } from './sprint-3/day-4/assignments/RoutingAssignment/contest/AuthProvider.jsx';
import { BrowserRouter } from "react-router-dom"
import AuthContextProvider from './sprint-3/day-3/assignments/ContextAssignment/contest/AuthContextProvider';
import { Provider } from 'react-redux';
import ModeProvider from './sprint-3/day-3/assignments/ContestFigmaAssignment/contest/ModeProvider';
import {store} from './sprint-4/evaluation/ReduxThunk/store'
const container = document.getElementById("root");
const root = createRoot(container)


root.render(


    //<AuthContextProvider>


    // <ModeProvider>
//<Provider store={store}>
    
    <BrowserRouter>
    <AuthProvider>
    <App />
    </AuthProvider>
    </BrowserRouter>
//</Provider>

    // </ModeProvider>



    //</AuthContextProvider>



);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
